import { render } from "./WRORobot.vue?vue&type=template&id=acef9af4&scoped=true"
import script from "./WRORobot.vue?vue&type=script&lang=js"
export * from "./WRORobot.vue?vue&type=script&lang=js"

import "./WRORobot.vue?vue&type=style&index=0&id=acef9af4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acef9af4"]])

export default __exports__